import { createSlice } from '@reduxjs/toolkit'

const backButtonSlice = createSlice({
  name: 'backButton',
  initialState: {
    show: false,
    onClick: null,
  },
  reducers: {
    setShowBackButton: (state, action) => {
      state.show = action.payload.show
      state.onClick = action.payload.onClick
    },
  },
})

export const { setShowBackButton } = backButtonSlice.actions
export default backButtonSlice
